import { render, staticRenderFns } from "./ClientCredentialsRevokeTokens.vue?vue&type=template&id=3dc8ff7a&scoped=true"
import script from "./ClientCredentialsRevokeTokens.vue?vue&type=script&lang=js"
export * from "./ClientCredentialsRevokeTokens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc8ff7a",
  null
  
)

export default component.exports